import Box from '@mui/material/Box';

const Topbar = (): JSX.Element => {
  // Fetch user profile
  // const fetchUserProfile = () => {
  //   getLoggedInUserProfile()
  //     .then((response) => {
  //       setIsLoggedIn(true);
  //       //setUserName(`${response.data.firstName} ${response.data.lastName}`);

  //       const userRole =
  //         response.data.authorities && response.data.authorities[0]?.authority;
  //       setRole(userRole?.replace('ROLE_', '').toLowerCase() || '');
  //     })
  //     .catch(() => {
  //       setIsLoggedIn(false);
  //       setUserName('');
  //       setRole('');
  //     });
  // };

  // Fetch cart count
  // const fetchCartItemCount = () => {
  //   getCartItemsCount()
  //     .then((response) => {
  //       setCartItemCount(response.data); // Assuming the response contains the total quantity
  //     })
  //     .catch(() => {
  //       setCartItemCount(0); // Default to 0 if there's an error fetching the cart count
  //     });
  // };

  // Fetch profile and cart count on component load, on route change, or when browser navigation key changes

  // const getDashboardUrl = () => {
  //   switch (role) {
  //     case 'system':
  //       return '/system/dashboard/sections';
  //     case 'admin':
  //       return '/admin/dashboard';
  //     case 'manager':
  //       return '/manager/dashboard';
  //     case 'user':
  //       return '/user/dashboard';
  //     default:
  //       return '/';
  //   }
  // };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width={1}
    >
      <Box component="a" href="/" title="docket" width={{ xs: 100, md: 120 }}>
        <img src={'/assets/logo.png'} width={210} alt="Docket" />
      </Box>
    </Box>
  );
};

export default Topbar;
